import type { SelectOption } from '@/ui/advancedAssistants/MMA/types/Filter'
import FrokMultiSelect from '@/ui/components/FrokMultiSelect/FrokMultiSelect'
import './HandoverProductionLine.scss'
import { TextField } from '@bosch/react-frok/lib/esm/atoms/textField/textField'
import { Button } from '@bosch/react-frok/lib/esm/atoms/button/button'

const HandoverProductionLine = ({ lines, selection, onSelect, translate }: { lines: SelectOption[], selection: SelectOption[], onSelect: (lines: SelectOption[]) => void, translate: (key: string) => string }) => {
    const handleChange = (newValue: SelectOption[] | null) => {
        onSelect(newValue && newValue.length > 0 ? [{ value: newValue[0].value, label: newValue[0].label }] : [])
    }

    return (
        <div className="handover-production-line">
            {selection.length > 0 ? (
                <div className="handover-production-line__line-selection__selected-wrapper">
                    <TextField
                        id="line-field"
                        label={translate('handover:productionLineLabel')}
                        value={selection[0].label}
                        readOnly
                    />
                    <Button
                        mode="integrated"
                        icon="delete"
                        aria-label="Remove line"
                        onClick={() => onSelect([])}
                        className="handover-production-line__line-selection__remove-btn"
                    />
                </div>
            ) : (
                <FrokMultiSelect
                    label={translate('handover:productionLineLabel')}
                    placeholder={translate('handover:productionLinePlaceholder')}
                    options={lines}
                    value={selection ?? null}
                    onChange={handleChange}
                    isDisabled={lines.length === 0}
                />
            )}
        </div>
    )
}

export default HandoverProductionLine
